module.exports = __webpack_public_path__ + "img/img-147.a5fd9cbd.png";